import TelephoneWidget from "./TelephoneWidget";

export default TelephoneWidget;